import { Lens, Fold } from "@discovery/prelude/lib/control/lens";
import * as M from "@discovery/prelude/lib/data/maybe";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Article2Body, } from "@discovery/sonic-api-ng-optics-gen/lib/article";
export * from "@discovery/sonic-api-ng-optics-gen/lib/article";
export const _Article2RichTextContent = Fold.compose(_Article2Body, Res._Response(), Lens.path("attributes", "richTextContent"));
export const _ArticleRichTextContentBlocks = Fold.compose(_Article2RichTextContent, Lens.prop("blocks"), Fold._each());
export const _ArticleRichTextContentEntityMap = Fold.compose(_Article2RichTextContent, Lens.prop("entityMap"));
export const _ArticleRichTextAST = Fold.liftA2((blocks) => (map) => ({
    blocks: blocks.map((x) => ({
        data: M.fromMaybe(x.data, {}),
        depth: M.fromMaybe(x.depth, 0),
        key: M.fromMaybe(x.key, Math.random().toString()),
        text: x.text,
        type: x.type,
        entityRanges: M.fromMaybe(x.entityRanges, []),
        inlineStyleRanges: M.fromMaybe(x.inlineStyleRanges, []),
    })),
    entityMap: map,
}), Fold.compose(_Article2RichTextContent, Lens.prop("blocks")), _ArticleRichTextContentEntityMap);

